import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
// import toaster from 'utils/toaster';

const deleteTimesheetImage = (id: string) => {
  const newEndpoint = endpoints.timesheet.filesById.replace('{fileId}', id);
  return http().delete(newEndpoint);
};

export function useDeleteTimesheetImage() {
  return useMutation({ mutationFn: deleteTimesheetImage });
}
